import apiService, { defaultHeaders } from 'services/apiService';


/**
 * getActivityTypesForFilters
 * @param {object} activityTypes list of activities type
 * @returns {object} activities types object for filters
 */
export const getActivityTypesForFilters = activityTypes => activityTypes.reduce(
  (acc, { value: { category, label, categoryLabel }, key }) => {
    const [,, value] = key.split('.');
    if (acc.some(item => item.categoryLabel === categoryLabel)) {
      return acc.map(item => {
        if (item.categoryLabel === categoryLabel) {
          const children = (item.children.includes(categoryLabel))
            ? item.children
            : [...item.children, { label, value }];

          return {
            ...item,
            children,
          };
        }
        return item;
      });
    }
    return [
      ...acc,
      { category, categoryLabel, children: [{ label, value }] },
    ];
  }, [],
);

/**
 * getValueFiltered
 *
 * @param {object} value of the day
 * @param {object} filters containing `zones`, `activities` and `status` arrays
 * @returns {object} the list of data filtered
 */
export const getValueFiltered = (value, filters, index) => {
  const { userrequest:
  id,
  zone,
  eventType,
  state,
  participants,
  owner,
  structure,
  parkings } = value;
  const { zones, activities, status } = filters;
  const isZoneMatch = zones.includes(value.zone) || zones.includes('all');
  const isActivityMatch = activities.includes(eventType) || activities.includes('all');
  const isStatusMatch = status.includes(state.toString()) || status.includes('all');

  if (!isZoneMatch || !isActivityMatch || !isStatusMatch) {
    return {};
  }
  return {
    key: id + zone + index,
    id,
    zone: [zone],
    type: [eventType],
    status: state,
    participants,
    owner,
    structure,
    parkings,
  };
};

/**
 * getListData
 *
 * @param {object} moment date
 * @param {object} state containing `data` object and stored `date`
 * @param {object} filters containing `zones`, `activities` and `status` arrays
 * @returns {object} the list of data necessary for calendar
 */
export const getListData = (day, data = {}, filters) => {
  if (!Object.keys(data).length || !data[day.date()]) {
    return [];
  }
  return data[day.date()].reduce((acc, value, index) => {
    const valueFiltered = getValueFiltered(value, filters, index);
    if (acc.some(item => item.id === value.userrequest)) {
      return acc.map(userrequest => (
        (userrequest.id !== value.userrequest || Object.keys(valueFiltered).length === 0)
          ? userrequest
          : {
            ...userrequest,
            zone: [...new Set([...userrequest.zone, ...valueFiltered.zone])],
            type: [...new Set([...userrequest.type, ...valueFiltered.type])],
          }
      ));
    }
    return [
      ...acc,
      valueFiltered,
    ];
  }, []);
};

/**
 * Return list of zone
 * @param {object} data listed by day key
 * @returns {array} list of zone
 */
export const getZoneFromData = data =>
  Object.values(data)
    .reduce((days, day) => {
      const zonesByDay = day.reduce((list, item) => (
        list.includes(item.zone) ? list : [...list, item.zone]
      ), []);
      const filteredDays = zonesByDay.filter(item => !days.includes(item));
      return [...days, ...filteredDays];
    }, []);

/**
 * Return data
 * @param {string} date formatted as 'YYYY-D'
 * @returns {object} data filter by year and month
 */
export const getAgendaData = async date => {
  try {
    const { data: { value } } = await apiService.request(`/datastore/onf.agenda.${date}/`, {
      headers: defaultHeaders,
    });
    return value;
  } catch (e) {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/helpers/agendaHelpers.js